export default class BackgroundTools {

	static Cover (iw,ih,cw,ch) {

		const over = iw / ih
		const under = ih / iw
		const cRatio = cw / ch
		
		let w,h,pos={x:0,y:0}

		if (cRatio >= over) {
			w = cw
			h = Math.ceil(under * cw)
			pos.y = Math.abs((under * cw) - ch) / -2
		} else {
			w = Math.ceil(over * ch)
			h = ch
			pos.x = Math.abs((over * ch) - cw) / -2
		}

		return {w,h,pos}

	}

}



// WEBPACK FOOTER //
// ./src/utils/coverBackground.js